module.exports = __webpack_public_path__ + "static/media/pen-nib.6a4662f3.svg";